import { render } from "./ProductsV2.vue?vue&type=template&id=abd404c6&scoped=true"
import script from "./ProductsV2.vue?vue&type=script&lang=ts"
export * from "./ProductsV2.vue?vue&type=script&lang=ts"

import "./ProductsV2.vue?vue&type=style&index=0&id=abd404c6&scoped=true&lang=css"
import "./ProductsV2.vue?vue&type=style&index=1&id=abd404c6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-abd404c6"

export default script